import { Injectable } from "@angular/core";

export const TemplateNames = {
    companyDropDown: "companyDropDown",
    documentDropDown: "documentDropDown",
    documentLineItemDropDown: "documentLineItemDropDown",
    employeeDropDown: "employeeDropDown",
    identifierDescription: "identifierDescription",
    identifierNameDescription: "identifierNameDescription",
    processStepDetailDropDown: "processStepDetailDropDown",
    processStepDetailDropDownWithProgress: "processStepDetailDropDownWithProgress",
    processStepGroupDropDown: "processStepGroupDropDown",
    productDropDown: "productDropDown",
    resourceDropDown: "resourceDropDown",
    resourceTypeDropDown: "resourceTypeDropDown",
    storagePlaceDropDown: "storagePlace",
    documentTypeDropDown: "documentTypeDropDown"
}

@Injectable({
    providedIn: 'root'
})
export class TemplateService {

    getTemplate(name: string) {

        //todo check if custom template exists

        switch (name) {
            case TemplateNames.documentTypeDropDown:
                return "${identifier} - ${description}";
            case TemplateNames.employeeDropDown:
                return "${name} ${lastName} ${if(identifier)} - ${identifier}${/if}";
            case TemplateNames.identifierNameDescription:
                return "${identifier} ${if(name)} - ${name}${/if} ${if(description)} - ${description}${/if}";
            case TemplateNames.documentDropDown:
                return "${identifier}";
            case TemplateNames.documentLineItemDropDown:
                return "${product.identifier} (${quantity}x) - ${product.description}";
            case TemplateNames.processStepDetailDropDown:
                return "${processStepDefinition.identifier} - ${processStepDefinition.description}";
            case TemplateNames.processStepDetailDropDownWithProgress:
                return "${processStepDefinition.identifier} - ${processStepDefinition.description} (${status.finishedQuantity}/${status.quantity})";
            case TemplateNames.resourceDropDown:
                return "${identifier}${if(description)} - ${description}${/if}${if(scanId)} - ${scanId}${/if}";
            case TemplateNames.companyDropDown:
                return "${if(debitorId)}${debitorId}${/if}${if(creditorId)} ${creditorId}${/if} ${name} ${if(addition)} - ${addition}${/if}"
            case TemplateNames.identifierDescription:
            default:
                return "${identifier} ${if(description)} - ${description}${/if}";
        }
    }
}